import RelayEnvironment from './environment';

export const getRelayEnvironment = () => RelayEnvironment;
export { getRelayDataId } from './data-id';
